import { render, staticRenderFns } from "./LabelCategorySettings.vue?vue&type=template&id=41371714&scoped=true&"
import script from "./LabelCategorySettings.vue?vue&type=script&lang=js&"
export * from "./LabelCategorySettings.vue?vue&type=script&lang=js&"
import style0 from "./LabelCategorySettings.vue?vue&type=style&index=0&id=41371714&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41371714",
  null
  
)

export default component.exports